import type { TarifaDelPliego } from '../api'

export interface TextoTarifa {
  codigo: string
  energia: string
  demanda: string
  comercializacion: string
}

export const deLaTarifa = (t: TarifaDelPliego): TextoTarifa => ({
  codigo: t.codigo,
  energia: String(t.energia_usd_kwh),
  demanda: String(t.demanda_usd_kw_mes),
  comercializacion: String(t.comercializacion_usd_mes),
})

interface Props {
  tarifas: TarifaDelPliego[]
  valor: TextoTarifa
  alCambiar: (valor: TextoTarifa) => void
}

/**
 * Tarifa con demanda: se elige la del pliego y se corrige a mano con la planilla. Cada
 * valor distinto del pliego se marca, para que quien revise sepa que no es el oficial.
 */
export function CamposTarifa({ tarifas, valor, alCambiar }: Props) {
  const pliego = tarifas.find((t) => t.codigo === valor.codigo)
  const distinto = (texto: string, oficial?: number) => oficial !== undefined && Number(texto.replace(',', '.')) !== oficial
  const editada =
    !!pliego &&
    (distinto(valor.energia, pliego.energia_usd_kwh) ||
      distinto(valor.demanda, pliego.demanda_usd_kw_mes) ||
      distinto(valor.comercializacion, pliego.comercializacion_usd_mes))

  return (
    <fieldset className="grupo-campos">
      <legend>
        Tarifa del cliente{' '}
        <span className={`insignia ${editada ? 'insignia-pendiente' : 'insignia-cliente'}`}>{editada ? 'editada a mano' : 'pliego'}</span>
      </legend>
      <label className="ancho">
        Tarifa del pliego
        <select
          value={valor.codigo}
          onChange={(e) => {
            const elegida = tarifas.find((t) => t.codigo === e.target.value)
            if (elegida) alCambiar(deLaTarifa(elegida))
          }}
        >
          {tarifas.map((t) => (
            <option key={t.codigo} value={t.codigo}>
              {t.nombre}
            </option>
          ))}
        </select>
        {pliego && <small className="ayuda">Fuente: {pliego.fuente}</small>}
      </label>
      <label>
        Energía (USD/kWh)
        <input value={valor.energia} onChange={(e) => alCambiar({ ...valor, energia: e.target.value })} inputMode="decimal" />
      </label>
      <label>
        Demanda (USD/kW-mes)
        <input value={valor.demanda} onChange={(e) => alCambiar({ ...valor, demanda: e.target.value })} inputMode="decimal" />
      </label>
      <label>
        Comercialización (USD/mes)
        <input value={valor.comercializacion} onChange={(e) => alCambiar({ ...valor, comercializacion: e.target.value })} inputMode="decimal" />
        <small className="ayuda">Se paga igual con el sistema: no cuenta como ahorro.</small>
      </label>
      {editada && pliego && (
        <button type="button" className="enlace" onClick={() => alCambiar(deLaTarifa(pliego))}>
          Volver a la del pliego
        </button>
      )}
    </fieldset>
  )
}
